<template>
	<Dropdown :align="align">
		<a href="javascript:void(0)" slot="toggle">
			<div class="flex items-center p-0 font-normal text-white">
				<IconGlobe />
				<span class="ml-2">
					{{ $store.state.locale.toLowerCase() }}
				</span>
			</div>
		</a>
		<DropdownItem @click="changeLocaleTo('en')">
			English
		</DropdownItem>
		<DropdownItem @click="changeLocaleTo('de')">
			Deutsch
		</DropdownItem>
	</Dropdown>
</template>

<script>
import DropdownItem from '~/components/ui/common/DropdownItem'
import Dropdown from '~/components/ui/common/Dropdown'
import { IconGlobe } from '~/components/Icons'

export default {
	components: {
		DropdownItem,
		Dropdown,
		IconGlobe
	},
	props: {
		align: {
			type: String
		}
	},
	methods: {
		changeLocaleTo(locale) {
			if (this.$store.state.locale === locale) return
			if (!this.$store.state.locales.includes(locale)) return

			this.$store.dispatch('changeLocale', locale)
		}
	}
}
</script>
